export default __webpack_public_path__ + "static/media/circle-with-tick.0f795f7a.svg";